import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import api from '../../services/api';
import { formatLocalDateYYYYMMDD } from '../../utils/localDate';
import EnthusiasmDailyPath from '../../components/student/EnthusiasmDailyPath';
import StudentActivityQuickBar from '../../components/student/StudentActivityQuickBar';
import StudentHomeChallengesBanner from '../../components/student/StudentHomeChallengesBanner';
import StudentSeasonEnthusiasmBar from '../../components/student/StudentSeasonEnthusiasmBar';

const ENTHUSIASM_PANEL_ID = 'student-enthusiasm-panel';

/**
 * الصفحة الرئيسية للطالب — بطاقة الحماسة والترحيب في الأعلى، ثم مسار الأنشطة.
 */
const StudentHome = () => {
  const { isRTL } = useLanguage();
  const { user } = useAuth();

  const [dailyLoading, setDailyLoading] = useState(true);
  const [dailyData, setDailyData] = useState(null);

  useEffect(() => {
    if (!user?.id) {
      setDailyLoading(false);
      setDailyData(null);
      return;
    }
    let cancelled = false;
    (async () => {
      setDailyLoading(true);
      try {
        const res = await api.get(`/students/user/${user.id}/enthusiasm/daily`, {
          params: { date: formatLocalDateYYYYMMDD(new Date()) },
        });
        if (!cancelled && res.data?.success) {
          setDailyData(res.data.data);
        } else if (!cancelled) {
          setDailyData(null);
        }
      } catch {
        if (!cancelled) setDailyData(null);
      } finally {
        if (!cancelled) setDailyLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user?.id]);

  return (
    <div className="w-full min-h-[50vh]" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="mx-auto max-w-5xl space-y-6 sm:space-y-8">
        <div className="min-w-0">
          <StudentSeasonEnthusiasmBar
            dailyData={dailyData}
            dailyLoading={dailyLoading}
            anchorId={ENTHUSIASM_PANEL_ID}
          />
        </div>

        <div className="min-w-0">
          <StudentActivityQuickBar />
        </div>

        <StudentHomeChallengesBanner />

        <div className="flex flex-col gap-8 sm:gap-10 lg:gap-12">
          <div className="min-w-0">
            <EnthusiasmDailyPath breakdown={dailyData?.breakdown} loading={dailyLoading} />
          </div>
        </div>

        <div className="min-h-[10vh] w-full" data-student-home-root />
      </div>
    </div>
  );
};

export default StudentHome;
